import {
  FeatureExpansionRequestTypes,
  type FeatureExpansionRequestType,
} from '@webapp/core/services/Marketo'

export const NAVATTIC_CAPTURE_BASE_URL = 'https://capture.navattic.com'

export const PRODUCT_TOUR_DEMO_IDS: Partial<
  Record<FeatureExpansionRequestType, string>
> = {
  [FeatureExpansionRequestTypes.AP]: 'cmt8r2lwb000n04jr7aloemo8',
  [FeatureExpansionRequestTypes.CONTRACTS]: 'cmt8qrmnz000b04ld8j5mefwe',
  [FeatureExpansionRequestTypes.GUIDED_INTAKE]: 'cmt8qwgvj000a04jxcj4o9esf',
  [FeatureExpansionRequestTypes.VENDOR_PORTAL]: 'cmuzjjpwx001d06loaetj1ajb',
}
